import { motion } from "framer-motion";

const ease = [0.76, 0, 0.24, 1];

export const MaskText = ({ lines = [], className = "", delay = 0, once = true }) => {
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.09, delayChildren: delay } },
  };
  const child = {
    hidden: { y: "110%" },
    show: { y: "0%", transition: { duration: 1.1, ease } },
  };
  return (
    <motion.div
      className={className}
      variants={container}
      initial="hidden"
      whileInView="show"
      viewport={{ once, amount: 0.1 }}
    >
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span className="block" variants={child}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.div>
  );
};

export const FadeUp = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease, delay }}
  >
    {children}
  </motion.div>
);
